import { UserProfile } from "../models";
import api from "./config/axios.config";
const companyId = 1;
export const getUserProfile = async (): Promise<UserProfile | null> => {
  try {
     // Ajusta esta lógica según sea necesario
    const response = await api.get("/users/me", {
      headers: {
        companyId: companyId.toString(),
      },
    });
    return response.data as UserProfile;
  } catch (error) {
    console.error("Error while fetching user profile:", error);
    return null;
  }
};

// Función para actualizar el perfil de usuario
export const updateUserProfile = async (
  profileData: Partial<UserProfile>
): Promise<UserProfile> => {
  const response = await api.patch("/users/me", profileData, {
    headers: {
      companyId: companyId.toString(),
    },
  });
  return response.data;
};

export const changeUserPassword = async (
  oldPassword: string,
  newPassword: string
): Promise<boolean> => {
  try {
    const response = await api.patch("/users/me/change-password", {
      oldPassword,
      password: newPassword,
    });

    return response.status === 200;
  } catch (error) {
    console.error("Error while changing password:", error);
    return false;
  }
};
